<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>领券详情</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="领取用户" prop="qrUserInfo">
            <el-input v-model="searchForm.qrUserInfo" placeholder="请输入领取用户"></el-input>
          </el-form-item>
          <el-form-item label="领取时间" prop="brandId">
            <el-date-picker v-model="receiveTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :clearable="true"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否使用" prop="isUse">
            <el-select v-model="searchForm.isUse" placeholder="请选择是否使用" filterable clearable>
              <el-option v-for="item in isUses" :key="item.dictId" :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用时间" prop="brandId">
            <el-date-picker v-model="useTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :clearable="true"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
            <el-button type="primary" plain @click="getList('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-upload2" @click="deriveDeliver()">导出明细</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      isUses: [
        {
          dictId: '0',
          dictName: '否'
        },
        {
          dictId: '1',
          dictName: '是'
        }
      ],
      dataList: {
        list: [
          { title: '优惠券管理', path: '', type: '0' },
          { title: '领券详情', path: '', type: '1' }
        ]
      },
      getTime: [],
      useTime: [],
      receiveTime: [],
      searchForm: {
        couponId: '',
        qrUserInfo: '',
        receiveTimeStart: '',
        receiveTimeEnd: '',
        useTimeStart: '',
        useTimeStart: '',
        isUse: null,
        pageNo: 1,
        pageSize: 10,
        orderNo: ''
      },
      levels: [
        {
          dictId: '0',
          dictName: '普通用户'
        },
        {
          dictId: '1',
          dictName: '会员用户'
        }
      ],
      openTime: [],
      statuss: [
        {
          id: '0',
          name: '未上线'
        },
        {
          id: '1',
          name: '已上线'
        }
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { label: '领取时间', prop: 'receiveTime', minWidth: '120' },
        {
          label: '领取用户', prop: 'name', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p style='text-align:center;'>{scope.row.receiveUserName}</p>
                <p style='text-align:center;'>{scope.row.receiveUserPhone}</p>
              </div>
            )
          }
        },
        { label: '是否使用', prop: 'isUseLab', minWidth: '120' },
        {
          label: '使用时间', prop: 'useTime', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.useTime ? scope.row.useTime : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '订单编号', prop: 'orderNo', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.orderNo ? scope.row.orderNo : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '订单金额', prop: 'orderPrice', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.orderPrice ? scope.row.orderPrice : '--'}</p>
              </div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false
    }
  },
  created() {
    // this.getCategoryList()
    // this.getDictionaries('platform_vip_level')
    this.getList()
  },

  mounted() {

  },
  methods: {
    //导出
    deriveDeliver() {
      this.axios.post('/coupon/bind/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList(type) {
      this.searchForm.couponId = this.$route.query.id
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.couponId = this.$route.query.id
        this.useTime = []
        this.receiveTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.receiveTime) {
        this.searchForm.receiveTimeStart = this.receiveTime[0]
        this.searchForm.receiveTimeEnd = this.receiveTime[1]
      } else {
        this.searchForm.receiveTimeStart = ''
        this.searchForm.receiveTimeEnd = ''
      }
      if (this.useTime) {
        this.searchForm.useTimeStart = this.useTime[0]
        this.searchForm.useTimeEnd = this.useTime[1]
      } else {
        this.searchForm.useTimeStart = ''
        this.searchForm.useTimeEnd = ''
      }
      this.axios.post('/coupon/bind/pageList', this.searchForm).then(res => {
        if (res.code == 0) {
          // res.data.list.forEach(item => {
          //   if (item.level == 0) {
          //     item.levelLabel = '普通用户'
          //   } else {
          //     item.levelLabel = '会员用户'
          //   }
          // })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add(type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  